import { render, staticRenderFns } from "./detay.vue?vue&type=template&id=71b6ad4d&scoped=true&"
import script from "./detay.vue?vue&type=script&lang=js&"
export * from "./detay.vue?vue&type=script&lang=js&"
import style0 from "./detay.vue?vue&type=style&index=0&id=71b6ad4d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b6ad4d",
  null
  
)

export default component.exports